import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostInitiativeExportStartRequest = {
	filters?: string;
	initiativeId: number;
};

export type PostInitiativeExportStartResponse = { id: number };

export const postInitiativeExportStart = createPostEndpoint<
	PostInitiativeExportStartRequest,
	PostInitiativeExportStartResponse
>((request) => `/api/v3/core/exports/initiatives/${request.initiativeId}/export/start`);
